
import React, { Component } from 'react';
import OrderHandler from '../app/User/Handler/OrderHandler';
import { TableSessionType } from '../app/Common/Enum/TableSessionType';
import ConfirmModal from './modal/ConfirmModal';
import Navigator from '../app/User/Navigator/Navigator';
import ConfirmAddressModal from '../app/User/SelectDeliveryLocation/component/ConfirmAddressModal';
import { buildFullAddress } from './PickupInformation';
import PickupOrderMode from '../Model/PickupOrderMode';
import AppData from './../Model/AppData';
import { TableType } from '../components/merchant/Enum/TableType';
class TableInfoBar extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
        this.tableName = <span style={{color:"#777"}} className="">{lang.table + " " + this.props.table.name}</span>
    }
    componentWillReceiveProps(nextProps) {

    }
    onChangeOrderModeClicked = () => {
        const closeModal = () => this.setState({changeOrderModeModal:null})

        let isDelivery = OrderHandler.getTableSessionType() == TableSessionType.DELIVERY
        let yesText = null// isDelivery ? "Change delivery location" : "Delivery"
        let noText = null //isDelivery ? "Change to pickup" : "Continue with Pickup"
        let onYes = null
        let onNo = null
        if (isDelivery) {
            // We are at delivery mode
            // 1. Change delivery location
            // 2. Change to pickup
            yesText = lang.change_delivery_address
            noText = lang.change_pickup

            onYes = () => {
                closeModal()
                Navigator.goToSelectDeliveryLocation({
                    back: Navigator.goToCategory('url'),
                    hideFooter: true,
                })
            }

            onNo = () => {
                OrderHandler.clearDeliveryData()
                OrderHandler.setTableSessionType(TableSessionType.PICKUP)
                closeModal()
            }

            let message = ""
            this.setState({
                changeOrderModeModal: <ConfirmAddressModal
                    message={message}
                    addressComponents={OrderHandler.getDeliveryAddressComponents()}
                    distanceData={OrderHandler.getDeliveryDistanceData()}
                    streetNumber={OrderHandler.getDeliveryStreetNumber()}
                    buttonLayout="vertical"
                    onClose={closeModal}
                    onYes={onYes}
                    yesText={yesText}
                    onNo={onNo}
                    noText={noText}
                />,
            })
        }
        else {
            // We are Pickup mode
            // 1. Change to delivery mode
            // 2. Continue with Pickup
            yesText = lang.change_delivery
            noText = lang.continue_pickup

            onYes = () => {
                closeModal()
                Navigator.goToSelectDeliveryLocation({
                    back: Navigator.goToCategory('url'),
                    hideFooter: true,
                })
            }

            onNo = () => {
                closeModal()
            }

            this.setState({
                changeOrderModeModal: <ConfirmModal
                    message={lang.choose_mode}
                    buttonLayout="vertical"
                    onClose={closeModal}
                    onYes={onYes}
                    yesText={yesText}
                    onNo={onNo}
                    noText={noText}
                />
            })
        }
    }
    deliveryOnlyTable = (table) => {
        return table.delivery && !table.pickup
    }
    render() {
        const fullAddress = OrderHandler.getDeliveryDetail() && buildFullAddress(OrderHandler.getDeliveryDetail())
        return (
            <>
                {this.state.changeOrderModeModal}
                <div style={{...this.props.style, paddingTop:"15px", paddingBottom: "5px", display:"flex"}}>
                    <div style={{flex: "1 0 100px"}}>
                        <span>
                            <h4>{this.props.app.state.merchant && this.props.app.state.merchant.name}</h4>
                        </span>
                    </div>
                    <div style={{flex: "0 0 100px", textAlign:"right", margin: "auto"}}>
                        <span style={{color:"#777"}}>
                            <TableName table={this.props.table} onChangeOrderModeClicked={this.onChangeOrderModeClicked} />
                        </span>
                    </div>
                </div>
                {
                    this.deliveryOnlyTable(this.props.table) && fullAddress &&
                    <div className="mb-2">
                        <strong>{lang.deliver_to} </strong> { fullAddress }
                    </div>
                }
            </>
        );
    }
}

function TableName({table, onChangeOrderModeClicked}) {
    const isDineInWithPaymentTable = (table.table_type_bitwise & TableType.BIT_DINE_IN_WITH_PAYMENT) > 0
    if (isDineInWithPaymentTable) {
        return <h4>{lang.dine_in}</h4>
    }
    else if (table.pickup && table.delivery) {
        return <PickupDeliveryChanger onChangeOrderModeClicked={onChangeOrderModeClicked}/>
    }
    else if (table.pickup) {
        let pickupOrderModes = PickupOrderMode.getPickupOrderModes()
        const orderMode = AppData.data.state.current_session?.order_mode
        if (pickupOrderModes.length > 1) {
            if (orderMode) {
                return <h4>{orderMode}</h4>
            }
            return null
        }
        else {
            return <h4>{lang.pickup}</h4>
        }
    }
    else if (table.delivery) {
        return <DeliveryAddressChanger onChangeOrderModeClicked={onChangeOrderModeClicked} table={table}/>
    }
    else {
        return <h4>
            {lang.table + " " + table.name}
        </h4>
    }
}

function PickupDeliveryChanger({onChangeOrderModeClicked}) {
    let tableSessionType = OrderHandler.getTableSessionType()
    let isDelivery = tableSessionType == TableSessionType.DELIVERY
    return <button className="btn btn-default" onClick={onChangeOrderModeClicked}>
        {
            isDelivery ? lang.delivery : lang.pickup
        }
    </button>
}

function DeliveryAddressChanger({table, onChangeOrderModeClicked}) {
    let tableSessionType = table.table_type_bitwise
    let isDelivery = tableSessionType == TableSessionType.DELIVERY
    return <button className="btn btn-default" onClick={ () =>
        Navigator.goToSelectDeliveryLocation({
            back: Navigator.goToCategory('url'),
            hideFooter: true,
        })}>
        Change Address
    </button>
}

export default TableInfoBar;